export default __webpack_public_path__ + "static/media/ex-blog-posts.983fddeb.jpg";